// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"xk","footerTopLinks":"yk","footerFeedback":"zk","footerSocial":"Ak","footerLegalLinks":"Bk","footerIconCards":"Ck","footerBotCopy":"Dk","screenReadersOnly":"Ek"};